import React, { useRef } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import "modules/streaming/mobile.scss";
import "./Container.scss";
import { RoomWhiteboardContainer } from "modules/roomWhiteboard/RoomWhiteboardContainer";
import TrialBanner from "modules/trial/TrialBanner";
import { InEventTrialBanner } from "modules/trial/components";
import { selectIsEventManager } from "modules/event/selectors";
import FreePlanUsageAlert from "modules/freePlanUsageAlert/FreePlanUsageAlert";
import { TopBar } from "modules/topBar";
import { SurveyContainer } from "modules/guestExperienceSurvey";
import ConversationMenu from "modules/conversation/components/BottomMenu/BottomMenu";
import { JoinTableDialog } from "modules/conversation/components";
import EmojiReactionsContainer from "modules/emoji/Reactions/EmojiReactionsContainer";
import { selectLayout } from "modules/audioVideo/redux/selectors";
import { DailyContainer, DisplayLayout } from "modules/audioVideo";
import { useStyles } from "./styles";

const ConversationContainer = () => {
  const styles = useStyles();
  const conversationRef = useRef<HTMLDivElement>(null);
  const isEventManager = useSelector(selectIsEventManager);

  const layout = useSelector(selectLayout);

  const isMapMode = layout === DisplayLayout.Map;

  return (
    <div
      ref={conversationRef}
      data-testid="conversation-container"
      className={classNames(styles.root, { [styles.focusedView]: !isMapMode })}
    >
      <TopBar />
      <div className={styles.freePlanUsageAlert}>
        {isEventManager && <FreePlanUsageAlert />}
      </div>
      <div className={styles.trialBanner}>
        {isEventManager ? <TrialBanner /> : <InEventTrialBanner />}
      </div>
      <div className={styles.conversationContainer}>
        <DailyContainer />
        <RoomWhiteboardContainer />
        <EmojiReactionsContainer />
      </div>
      <div className={styles.conversationBottomBar}>
        <JoinTableDialog />
        <ConversationMenu />
      </div>
      <SurveyContainer />
    </div>
  );
};

export default React.memo(ConversationContainer);
